import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Titulo from '../../components/tipografia/Titulo';
import Descricao from '../../components/tipografia/Descricao';
import VBox from '../../components/layout/VBox';
import HBox from '../../components/layout/HBox';
import Icon from '../../components/Icon';
import { mdiBullhorn, mdiStar } from '@mdi/js';

const PageMovida = () => {
  return (
    <LayoutUsuario>
      <VBox center vcenter gap="32px" style={{ height: 'calc(100vh - 64px)', width: '100%' }}>
        <VBox center gap="16px" style={{ maxWidth: '480px', textAlign: 'center' }}>
          <div><Icon path={mdiBullhorn} size={3} color="var(--tc-color-brand-primary)" /></div>
          <Titulo>Campanhas foi para o CRM</Titulo>
          <Descricao>
            A seção de <strong>Campanhas</strong> foi movida para o módulo{' '}
            <strong>CRM</strong>, onde você pode gerenciá-la junto com seus
            contatos e vendas.
          </Descricao>
          <HBox gap="12px" style={{ justifyContent: 'center', alignItems: 'center', marginTop: '8px' }}>
            <Icon path={mdiStar} size={0.9} color="var(--tc-color-brand-primary)" />
            <span style={{ color: 'var(--tc-color-gray-600)' }}>
              CRM &rsaquo; Campanhas
            </span>
          </HBox>
        </VBox>
      </VBox>
    </LayoutUsuario>
  );
};

export default PageMovida;
